import { gql } from '@apollo/client'

import { INGREDIENT_NODE_FRAGMENT } from '../fragments'

const SET_IS_CURATION_ENABLED_INGREDIENT_MUTATION = gql`
  mutation setIsCurationEnabledIngredient(
    $id: ID!
    $isCurationEnabled: Boolean!
  ) {
    setIsCurationEnabledIngredient(
      id: $id
      isCurationEnabled: $isCurationEnabled
    ) {
      ...IngredientNodeFragment
    }
  }
  ${INGREDIENT_NODE_FRAGMENT}
`

export default SET_IS_CURATION_ENABLED_INGREDIENT_MUTATION
